module.exports = __webpack_public_path__ + "img/info.951df68c.svg";